export enum APIRequestLogAction {
  CREATE_APPOINTMENT = 'create_appointment',
  UPDATE_APPOINTMENT = 'update_appointment'
}

export interface IAPIRequestLog {
  // Required fields
  id: string;
  action: APIRequestLogAction;
  apiUserId: string;
  dockId: string;
  orgId: string;
  loadTypeId: string;
  statusCode: number;
  statusMessage: string;
  createDateTime: Date;
  warehouseId: string;

  // Optional fields
  appointmentId?: string;
  appointmentStart?: Date;
  appointmentUserId?: string;
  traceId?: string;
  userAgent?: string;
}
